export default __webpack_public_path__ + "de85080f37588cc0e2df390203721dbd.wav";